<template>
    <div>
        <el-cascader
            v-model="convertedVal"
            ref="DataCascader"
            :multiple="multiple"
            :disabled="disabled"
            :placeholder="placeholder"
            @change="handleChange"
            :options="options"
            :clearable="clearable"
            style="width: 100%"
            :size="size"
            :props="{ multiple: multiple,checkStrictly:checkStrictly }"
        />
        <el-statistic v-if="isShowData && dataVal" :value="dataVal" style="display:inline-block;">
            <template slot="suffix">{{ $attrs.unit }}</template>
        </el-statistic>
    </div>
</template>
<script>
import { copy } from '@/utils'
export default {
    name: 'DataCascader',
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: true,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        isChange: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: '请选择',
        },
        value: {
            type: [Array, Object],
            default: () => [],
        },
        appId: {
            type: String,
            default: '',
        },
        options: {
            type: Array,
            default: () => [],
        },
        checkStrictly: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: '—',
        },
        isData: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        return {
            dataVal: 0,
        }
    },
    computed: {
        convertedVal: {
            get() {
                const { value, multiple } = this
                const _val = value.map(item => item.map(({ value }) => value))
                if (value[0] && value[0][0]) this.setDataVal()
                return multiple ? _val : _val[0]
            },
            set(val) {
                return val
            }
        },
        isShowData () {
            return this.isData
        }
    },
    methods: {
        setDataVal () {
            if (this.isData) {
                const { value } = this
                const valueArr = []
                value.forEach(item => {
                    const lastIndex = item.length - 1
                    const val = item[lastIndex].extraValue
                    if (Number(val)) valueArr.push(Number(val))
                })
                let count = 0
                valueArr.forEach(val => count += val)
                this.dataVal = count
            }
        },
        handleChange (value) {
            const { multiple } = this
            const nodesMap = {}
            this.$refs.DataCascader.getCheckedNodes(!this.checkStrictly).map(({ pathNodes }) => pathNodes).forEach(nodes => {
                nodes.forEach(({ value, data }) => {
                    const { children, ...res } = data
                    nodesMap[value] = res
                })
            })
            value.length ? this.setDataVal() : (this.dataVal = 0)// multiple ? value : [value]
            const _value = multiple ? copy(value) : [copy(value)]
            _value.forEach(item => {
                item.forEach((val, index) => {
                    item[index] = nodesMap[val]
                })
            })
            this.$emit('input', _value)
            this.$emit('change', _value)
        }
    }
}
</script>